import { Component, Input } from '@angular/core';

@Component({
  selector: 'payee-radio-button',
  templateUrl: './payee-radio-button.component.html',
  styleUrls: ['./payee-radio-button.component.scss'],
})
export class PayeeRadioButtonComponent {
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() checked = false;
}
